/*
 * File: AppointmentSpeedDialButton.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 05/03/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles the Edit Appointment button and form
 */
import React from "react";
import UIStore from "../store/UIStore";
import ApptFormDialog from "./ApptFormDialog";
import EditIcon from "@material-ui/icons/Edit";
import UIFab from "components/ui/UIFab";
import PropTypes from "prop-types";
import { useStore } from "utils/useStore";

const EditAppointmentButton = ({ editAppt }) => {
  const ui = useStore(UIStore);
  return (
    <React.Fragment>
      <UIFab
        icon={<EditIcon />}
        handleClick={ui.toggleFormDialog}
        name={"Edit Appointment"}
      />

      <ApptFormDialog title={"Edit Appointment"} appt={editAppt} />
    </React.Fragment>
  );
};

EditAppointmentButton.propTypes = {
  editAppt: PropTypes.object.isRequired
};

export default EditAppointmentButton;
